var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotValid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.676,
    height: 24.674,
    viewBox: "0 0 24.676 24.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f12b5d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.34,0a.77.77,0,0,0-.694.425L.08,23.558a.773.773,0,0,0,.691,1.116H23.9a.771.771,0,0,0,.775-.766.762.762,0,0,0-.082-.35L13.031.425A.777.777,0,0,0,12.34,0Zm0,2.5L22.653,23.132H2.021ZM12.328,9.71l-.079.006a.767.767,0,0,0-.682.778v7.081a.771.771,0,1,0,1.542.035V10.494a.773.773,0,0,0-.758-.784Zm.009,9.678a.9.9,0,1,0,.906.9A.9.9,0,0,0,12.337,19.388Z",
    transform: "translate(0.001 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotValid);
export default __webpack_public_path__ + "static/media/NotValid.80271fd8dc29410290460dec87ee8ffc.svg";
export { ForwardRef as ReactComponent };